export enum EVentilationGlobaleType {
    Absence = 1,
    RecycleurAir = 2,
    GeneraleMecanique = 3,
    DispositifHorsFonction = 4,
}